import React, { useState } from 'react';

const Tooltip = ({ content, children }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        className="inline-flex items-center"
      >
        {children}
      </div>
      
      {isVisible && (
        <div 
          className="absolute z-50 w-64 p-3 -mt-2 -ml-32 transform -translate-y-full bg-gray-800 text-white text-sm rounded-lg shadow-lg border border-gray-700 pointer-events-none"
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
        >
          <div className="relative">
            {content}
            <div className="absolute w-3 h-3 -bottom-5 left-1/2 transform -translate-x-1/2 rotate-45 bg-gray-800 border-r border-b border-gray-700"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;